export const LS_AUTH_TOKEN_KEY = "auto-token"

export function getAuthToken() {
  return localStorage.getItem(LS_AUTH_TOKEN_KEY)
}
export function setAuthToken(token: string) {
  localStorage.setItem(LS_AUTH_TOKEN_KEY, token)
}
export function clearAuthToken() {
  localStorage.removeItem(LS_AUTH_TOKEN_KEY)
}
